import { render, staticRenderFns } from "./EariningsAndDeductions.vue?vue&type=template&id=fa08d982"
import script from "./EariningsAndDeductions.vue?vue&type=script&lang=js"
export * from "./EariningsAndDeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports